import { useEffect } from "react";

const SRC = "https://elfsightcdn.com/platform.js";

// Renders an Elfsight widget (e.g. Google Reviews). Loads platform.js once and
// re-initialises on SPA navigation so the widget mounts reliably.
export const ElfsightWidget = ({ appId, className = "" }) => {
  useEffect(() => {
    const existing = document.querySelector(`script[src="${SRC}"]`);
    if (!existing) {
      const s = document.createElement("script");
      s.src = SRC;
      s.async = true;
      document.body.appendChild(s);
    } else if (window.eapps?.initWidgetsFromBuffer) {
      window.eapps.initWidgetsFromBuffer();
    }
  }, [appId]);

  return (
    <div
      key={appId}
      className={`elfsight-app-${appId} ${className}`}
      data-elfsight-app-lazy
      data-testid="elfsight-widget"
    />
  );
};
